import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "leaderboard"
}
const _hoisted_2 = { class: "leaderboard__profiles" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "leaderboard__name" }
const _hoisted_5 = { class: "mb-0 h6 fw-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "leaderboard__value"
}
const _hoisted_7 = {
  key: 1,
  class: "leaderboard__value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.sortedResults.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("main", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedResults, (result) => {
            return (_openBlock(), _createElementBlock("article", {
              class: "leaderboard__profile",
              key: result.userId
            }, [
              _createElementVNode("img", {
                src: result.userDetails?.userThumbnail ? _ctx.assetHost + '/' + result.userDetails?.userThumbnail : '/img/profile_not_found.png',
                onerror: "this.onerror=null; this.src='/img/profile_not_found.png'",
                alt: result.username,
                class: "leaderboard__picture"
              }, null, 8, _hoisted_3),
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, _toDisplayString(result.username), 1)
              ]),
              (result.isSolved)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(result.time), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[0] || (_cache[0] = [
                    _createElementVNode("div", {
                      class: "css3-spinner",
                      style: {"--cnvs-loader-color":"var(--cnvs-themecolor)"}
                    }, [
                      _createElementVNode("div", { class: "css3-spinner-bounce1" }),
                      _createElementVNode("div", { class: "css3-spinner-bounce2" }),
                      _createElementVNode("div", { class: "css3-spinner-bounce3" })
                    ], -1)
                  ])))
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}